var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{staticClass:"image-box flex-center",style:({
    '--scale': _vm.scale,
  }),attrs:{"src":_vm.src,"alt":_vm.alt,"lazy":_vm.lazy,"fit":_vm.fit}},[_c('div',{staticClass:"image-slot flex-col-center",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon el-icon-picture-outline"}),_c('div',{staticClass:"image-slot-text"},[_vm._v(_vm._s(_vm.$t('imgError') || '暂无图片'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }